/**
 * Single source of truth for the Murabbi Youth Initiative application form.
 *
 * If the form ever changes, update ONLY this constant and every
 * "Apply" button across the site will follow.
 */
export const MURABBI_APPLICATION_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfxFvN1JpJNGfpRSwfJO-uq9DwBxgfuMnC_BKMv0FG-lhwKxQ/viewform?usp=publish-editor";

/** Standard props for opening the form safely in a new tab. */
export const APPLICATION_LINK_PROPS = {
  href: MURABBI_APPLICATION_FORM_URL,
  target: "_blank",
  rel: "noopener noreferrer",
};
